import { appConfig } from '../config/appConfig';

type ClarityQueue = ((...args: unknown[]) => void) & { q?: unknown[][] };
type ClarityConsent = 'granted' | 'denied';
export type ClarityConsentState = {
  adStorage: ClarityConsent;
  analyticsStorage: ClarityConsent;
};

const toClarityConsentPayload = ({ adStorage, analyticsStorage }: ClarityConsentState) => ({
  ad_Storage: adStorage,
  analytics_Storage: analyticsStorage,
});

declare global {
  interface Window {
    clarity?: ClarityQueue;
  }
}

export function initializeClarity(
  consent: ClarityConsentState = { adStorage: 'granted', analyticsStorage: 'granted' },
) {
  const projectId = appConfig.clarityProjectId.trim();

  if (!import.meta.env.PROD || !appConfig.enableClarity || !projectId || window.clarity) {
    return;
  }

  window.clarity = (...args: unknown[]) => {
    (window.clarity!.q = window.clarity!.q || []).push(args);
  };

  setClarityConsentState(consent);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${encodeURIComponent(projectId)}`;
  document.head.appendChild(script);
}

export function setClarityConsent(consent: ClarityConsent) {
  window.clarity?.('consentv2', toClarityConsentPayload({ adStorage: consent, analyticsStorage: consent }));
}

export function setClarityConsentState(consent: ClarityConsentState) {
  window.clarity?.('consentv2', toClarityConsentPayload(consent));
}
